import { createSocketClient } from '@/shared/lib/socket/SharedWorkerClient';

const BITHUMB_WS_URL = 'wss://ws-api.bithumb.com/websocket/v1';

/**
 * Bithumb WebSocket 구독 메시지 생성.
 * Bithumb 형식: [{ ticket: '...' }, { type: 'ticker', codes: [...] }]
 */
const buildBithumbSubscribeMessage = (type: string, codes: string[]) => [
  { ticket: `bithumb-${type}` },
  { type, codes },
];

export const bithumbSocketManager = createSocketClient({
  exchange: 'bithumb',
  url: BITHUMB_WS_URL,
  buildSubscribeMessage: buildBithumbSubscribeMessage,
});
